import axios from "axios";
import { store } from "redux/store";
import { logoutAndClearSession } from "redux/auth/logoutAndClearSession";

// Separate Axios instance for the Spring Boot backend
const SpringApi = axios.create({
  baseURL: process.env.REACT_APP_SPRING_API_URL || "http://localhost:8080"
});

SpringApi.interceptors.request.use(
  async config => {
    if (localStorage.getItem("isLogin") === "true") {
      config.headers = {
        "access-token": localStorage.getItem("Authorization")
      };
    } else {
      config.headers = {};
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

SpringApi.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const status = error.response ? error.response.status : null;
    if (status === 401) {
      store.dispatch(logoutAndClearSession());
    }
    return Promise.reject(error);
  }
);

// ── Supplier endpoints ──
export const supplierAdd = data =>
  SpringApi.post("/api/admin/supplier/add", data);
export const supplierEdit = (id, data) =>
  SpringApi.put(`/api/admin/supplier/edit/${id}`, data);
export const supplierDelete = id =>
  SpringApi.delete(`/api/admin/supplier/delete/${id}`);
export const supplierList = (storesId, params) =>
  SpringApi.post(`/api/admin/supplier/list/${storesId}`, params);
export const supplierActive = storesId =>
  SpringApi.get(`/api/admin/supplier/activeSuppliers/${storesId}`);

// ── Purchase Order endpoints ──
export const purchaseOrderAdd = data =>
  SpringApi.post("/api/admin/purchaseOrder/add", data);
export const purchaseOrderEdit = (id, data) =>
  SpringApi.put(`/api/admin/purchaseOrder/edit/${id}`, data);
export const purchaseOrderDelete = id =>
  SpringApi.delete(`/api/admin/purchaseOrder/delete/${id}`);
export const purchaseOrderList = (storesId, params) =>
  SpringApi.post(`/api/admin/purchaseOrder/list/${storesId}`, params);
export const purchaseOrderView = id =>
  SpringApi.get(`/api/admin/purchaseOrder/view/${id}`);
export const purchaseOrderDashboard = storesId =>
  SpringApi.get(`/api/admin/purchaseOrder/dashboard/${storesId}`);

// ── Consent endpoints ──
export const consentAdd = data =>
  SpringApi.post("/api/admin/consent/add", data);
export const consentEdit = (id, data) =>
  SpringApi.put(`/api/admin/consent/edit/${id}`, data);
export const consentDelete = id =>
  SpringApi.delete(`/api/admin/consent/delete/${id}`);
export const consentList = (storesId, params) =>
  SpringApi.post(`/api/admin/consent/list/${storesId}`, params);

// ── Reschedule endpoints ──
export const rescheduleAdd = data =>
  SpringApi.post("/api/admin/reschedule/add", data);
export const rescheduleUpdateStatus = (id, status) =>
  SpringApi.put(`/api/admin/reschedule/updateStatus/${id}?status=${status}`);
export const rescheduleList = (storesId, params) =>
  SpringApi.post(`/api/admin/reschedule/list/${storesId}`, params);

// ── Email Log endpoints ──
export const emailLogList = (storesId, params) =>
  SpringApi.post(`/api/admin/emailLog/list/${storesId}`, params);
export const emailLogByOrder = orderId =>
  SpringApi.get(`/api/admin/emailLog/byOrder/${orderId}`);

// ── Parsed Invoice endpoints ──
export const listParsedInvoices = storesId =>
  SpringApi.get(`/api/admin/parsedInvoice/list?storesId=${storesId}`);

export const listAllParsedInvoices = () =>
  SpringApi.get(`/api/admin/parsedInvoice/all`);
export const getParsedInvoiceByReceipt = receiptId =>
  SpringApi.get(`/api/admin/parsedInvoice/byReceipt?receiptId=${receiptId}`);

// ── Webhook Config endpoints ──
export const getWebhookConfig = storesId =>
  SpringApi.get(`/api/admin/webhookConfig/get?storesId=${storesId}`);
export const saveWebhookConfig = (
  storesId,
  webhookUrl,
  webhookSecret,
  description,
  fallbackMinutes
) => {
  const params = new URLSearchParams({ storesId, webhookUrl });
  if (webhookSecret) params.append("webhookSecret", webhookSecret);
  if (description) params.append("description", description);
  if (fallbackMinutes != null)
    params.append("fallbackMinutes", fallbackMinutes);
  return SpringApi.post(`/api/admin/webhookConfig/save?${params.toString()}`);
};

// ── Engagement Suite (CES) endpoints ──
export const getEngagementConfigs = storesId =>
  SpringApi.get(`/api/admin/engagement/list/${storesId}`);
export const saveEngagementConfigs = (storesId, configs) =>
  SpringApi.post(`/api/admin/engagement/save/${storesId}`, configs);
export const toggleEngagementConfig = (configId, active) =>
  SpringApi.put(`/api/admin/engagement/toggle/${configId}?active=${active}`);

export default SpringApi;
